export class Exam {
  description!: String;
  cfu!: number;
  ssd!: string;
  vote: number | null = null;
  voteLabel: string | null = null;
}